module.exports = __webpack_public_path__ + "img/17.cdbf9962.png";